import React from 'react'

export type Props = {
    ms: number
}

export default function Duration({ ms }: Props) {
    return <>{renderDuration(ms)}</>
}

function renderDuration(ms: number) {
    let remaining = Math.floor(Math.abs(ms) / 1000)
    if (remaining < 1) return 'wenige Sekunden'

    const days = Math.floor(remaining / 60 / 60 / 24)
    remaining -= days * 60 * 60 * 24
    const daysS = days ? `${days} Tag${days === 1 ? '' : 'e'}` : ''

    const hours = Math.floor(remaining / 60 / 60)
    remaining -= hours * 60 * 60
    const hoursS = hours ? `${hours} Stunde${hours === 1 ? '' : 'n'}` : ''

    const minutes = Math.floor(remaining / 60)
    const minutesS = minutes ? `${minutes} Minute${minutes === 1 ? '' : 'n'}` : ''

    const seconds = remaining - minutes * 60
    const secondsS = seconds ? `${seconds} Sekunde${seconds === 1 ? '' : 'n'}` : ''

    if (days > 1) return daysS
    if (days) return `${daysS} ${hoursS}`.trim()

    if (hours > 1) return hoursS
    if (hours) return `${hoursS} ${minutesS}`.trim()

    if (minutes > 1) return minutesS
    if (minutes) return `${minutesS} ${secondsS}`.trim()

    return secondsS
}
